import { render, staticRenderFns } from "./FollowUpClients.vue?vue&type=template&id=731e4bc6&"
import script from "./FollowUpClients.vue?vue&type=script&lang=js&"
export * from "./FollowUpClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports